import { applySpec, assoc, compose, defaultTo, find, omit, propEq, propOr } from 'ramda';

export const groups = [
  {
    code: 'A1800',
    label: 'SAPEURS POMPIERS VOLONTAIRES DE GIRONDE',
    labelRouteDisplay: 'A1800-SAPEURS POMPIERS VOLONTAIRES DE GIRONDE'
  },
  {
    code: 'A1870',
    label: 'ASS. PAVILLON PREVOYANCE AGENTS TERRITORIAUX',
    labelRouteDisplay: 'A1870-ASS. PAVILLON PREVOYANCE AGENTS TERRITORIAUX'
  },
  {
    code: 'A1870A',
    label: 'MAIRIE DE LA COMMUNE DE TALENCE',
    labelRouteDisplay: 'A1870A-MAIRIE DE LA COMMUNE DE TALENCE'
  },
  {
    code: 'A1879',
    label: 'MAIRIE DE GUJAN MESTRAS',
    labelRouteDisplay: 'A1879-MAIRIE DE GUJAN MESTRAS'
  },
  {
    code: 'AD0012',
    label: 'LA SOLIDARITE D\'AQUITAINES',
    labelRouteDisplay: 'AD0012-LA SOLIDARITE D\'AQUITAINE'
  },
  {
    code: 'AD3090',
    label: 'ST MARTIN DE CARCANS',
    labelRouteDisplay: 'AD3090-ST MARTIN DE CARCANS'
  },
  {
    code: 'AD5046',
    label: 'UTF ANGOULEME/COGNAC',
    labelRouteDisplay: 'AD5046-UTF ANGOULEME/COGNAC'
  },
  {
    code: 'AD5102',
    label: 'UNION DES TRAVAILLEURS DE FRANCE',
    labelRouteDisplay: 'AD5102-UNION DES TRAVAILLEURS DE FRANCE'
  },
  {
    code: 'AD5160',
    label: 'UNION DES TRAVAILLEURS DE FRANCE',
    labelRouteDisplay: 'AD5160-UNION DES TRAVAILLEURS DE FRANCE'
  },
  {
    code: 'AD6023',
    label: 'MUTUELLE DE SAUVETERRE DE GUYENNE',
    labelRouteDisplay: 'AD6023-MUTUELLE DE SAUVETERRE DE GUYENNE'
  },
  {
    code: 'AD6115',
    label: 'SAINT MARTIN DE LESPARRE',
    labelRouteDisplay: 'AD6115-SAINT MARTIN DE LESPARRE'
  },
  {
    code: 'AD6350',
    label: 'UNION DES TRAVAILLEURS DE FRANCE',
    labelRouteDisplay: 'AD6350-UNION DES TRAVAILLEURS DE FRANCE'
  },
  {
    code: 'AD6442',
    label: 'L UNION FRATERNELLE DE LANSAC',
    labelRouteDisplay: 'AD6442-L UNION FRATERNELLE DE LANSAC'
  },
  {
    code: 'AD6471',
    label: 'UNION MUTUALISTE SAINT PIERRE',
    labelRouteDisplay: 'AD6471-UNION MUTUALISTE SAINT PIERRE'
  },
  {
    code: 'AD6471',
    label: 'UNION MUTUALISTE SAINT PIERRE',
    labelRouteDisplay: 'AD6471-UNION MUTUALISTE SAINT PIERRE'
  },
  {
    code: 'AD6706',
    label: 'SAINT MARTIN DE PESSAC',
    labelRouteDisplay: 'AD6706-SAINT MARTIN DE PESSAC'
  },
  {
    code: 'AD6856',
    label: 'SAINT QUENTIN SAINT ROMAIN',
    labelRouteDisplay: 'AD6856-SAINT QUENTIN SAINT ROMAIN'
  },
  {
    code: 'AD8066',
    label: 'UNION DES TRAVAILLEURS DE CASTEL',
    labelRouteDisplay: 'AD8066-UNION DES TRAVAILLEURS DE CASTEL'
  },
  {
    code: 'AD8180',
    label: 'ST VINCENT DE GRIGNOLS',
    labelRouteDisplay: 'AD8180-ST VINCENT DE GRIGNOLS'
  },
  {
    code: 'AD8284',
    label: 'LES AMIS DE PORTETS',
    labelRouteDisplay: 'AD8284-LES AMIS DE PORTETS'
  },
  {
    code: 'ASOF01',
    label: 'SOFRACO DIRIGEANTS ET MANDATAIRES',
    labelRouteDisplay: 'ASOF01-SOFRACO DIRIGEANTS ET MANDATAIRES'
  },
  {
    code: 'ATNSP',
    label: 'ASSOCIATION PAVILLON PREVOYANCE TNS',
    labelRouteDisplay: 'ATNSP-ASSOCIATION PAVILLON PREVOYANCE TNS'
  },
  {
    code: 'COUR_PP',
    label: 'Courtiers PP',
    labelRouteDisplay: 'COUR_PP-Courtiers PP'
  },
  {
    code: 'G2055',
    label: 'LA SOLIDARITE MARMANDAISE',
    labelRouteDisplay: 'G2055-LA SOLIDARITE MARMANDAISE'
  },
  {
    code: 'G2222',
    label: 'CENTRE COMMUNAL D ACTION SOCIAL',
    labelRouteDisplay: 'G2222-CENTRE COMMUNAL D ACTION SOCIAL'
  },
  {
    code: 'GP5206',
    label: 'MUTUELLE DE ST LAURENT MEDOC',
    labelRouteDisplay: 'GP5206-MUTUELLE DE ST LAURENT MEDOC'
  },
  {
    code: 'GP5332',
    label: 'LA FRATERNELLE CANAULAISE A LACANAU',
    labelRouteDisplay: 'GP5332-LA FRATERNELLE CANAULAISE A LACANAU'
  },
  {
    code: 'GP5482',
    label: 'ST JOSEPH DE LANGOIRAN',
    labelRouteDisplay: 'GP5482-ST JOSEPH DE LANGOIRAN'
  },
  {
    code: 'GP5814',
    label: 'SAINT JEAN BAPTISTE DE BLASIMON',
    labelRouteDisplay: 'GP5814-SAINT JEAN BAPTISTE DE BLASIMON'
  },
  {
    code: 'GP6023',
    label: 'MUTUELLE DE SAUVETERRE DE GUYENNE',
    labelRouteDisplay: 'GP6023-MUTUELLE DE SAUVETERRE DE GUYENNE'
  },
  {
    code: 'GP6064',
    label: 'LA FRATERNELLE  DE MOULON',
    labelRouteDisplay: 'GP6064-LA FRATERNELLE  DE MOULON'
  },
  {
    code: 'GP6115',
    label: 'SAINT MARTIN DE LESPARRE',
    labelRouteDisplay: 'GP6115-SAINT MARTIN DE LESPARRE'
  },
  {
    code: 'GP6471',
    label: 'UNION MUTUALISTE ST PIERRE',
    labelRouteDisplay: 'GP6471-UNION MUTUALISTE ST PIERRE'
  },
  {
    code: 'GP6856',
    label: 'SAINT QUENTIN SAINT ROMAIN',
    labelRouteDisplay: 'GP6856-SAINT QUENTIN SAINT ROMAIN'
  },
  {
    code: 'GP8066',
    label: 'UNION DES TRAVAILLEURS DE CASTEL',
    labelRouteDisplay: 'GP8066-UNION DES TRAVAILLEURS DE CASTEL'
  },
  {
    code: 'LOURMEL',
    label: 'COURTIERS LOURMEL',
    labelRouteDisplay: 'LOURMEL-COURTIERS LOURMEL'
  },
  {
    code: 'MIGRP',
    label: 'MUTUELLE INTERNET',
    labelRouteDisplay: 'MIGRP-MUTUELLE INTERNET'
  },
  {
    code: 'SOFRACO',
    label: 'Courtiers Sofraco',
    labelRouteDisplay: 'SOFRACO-Courtiers Sofraco'
  },
  {
    code: 'SOSOFT',
    label: 'SOSOFT',
    labelRouteDisplay: 'SOSOFT-SOSOFT'
  },
  {
    code: 'TERRI',
    label: 'Territoriaux',
    labelRouteDisplay: 'TERRI-Territoriaux'
  }
];

export const formatExtraDefaultValues = (props) => {
  return props;
};

export const formatExtraDataBeforeSubmit = (values) => {
  const findCustomGroup = compose(
    applySpec({
      customGroupExternalId: propOr('', 'code'),
      customGroupExternalCode: propOr('', 'label'),
      customGroupCode: propOr('', 'labelRouteDisplay')
    }),
    defaultTo({}),
    (data) => find(propEq('code', data.defaultGroupCode), groups)
  );

  return compose(omit(['defaultGroupCode', 'groupCodes']), (data) =>
    assoc('customGroup', findCustomGroup(data), data)
  )(values);
};
